import { Card } from '../../components/core/Card.jsx'
import { Alert } from '../../components/feedback/Alert.jsx'
import { AdminLayout, Table } from '../../admin/AdminLayout.jsx'

// Every customer account, newest first: who, what plan, whether the address is
// confirmed, how much of the month is used and what it has cost.
export default function AdminAccounts({ accounts = [], flash_notice = null }) {
  const rows = accounts.map((a) => ({
    ...a,
    who: (
      <span>
        {a.name}
        <br />
        <span className="text-[color:var(--text-muted)]">{a.email}{a.verified ? '' : ' · unconfirmed'}</span>
      </span>
    ),
    usage: `${a.used} / ${a.limit}`,
  }))

  return (
    <AdminLayout title="Accounts">
      {flash_notice && <Alert tone="data" icon="mail" title={flash_notice} />}
      <Card pad="md">
        <Table
          columns={[
            ['who', 'Account'], ['status', 'Status'], ['plan', 'Plan'], ['ends', 'Trial / comp ends'],
            ['businesses', 'Businesses', 'right'], ['usage', 'Questions this month', 'right'],
            ['spend', 'Spend this month', 'right'], ['created', 'Created'],
          ]}
          rows={rows}
          empty="No customer accounts yet."
        />
      </Card>
    </AdminLayout>
  )
}
